<div
    class="position-relative share-dialog-popup"
    [ngClass]="{ langArMobile: lang == 'ar' }"
>
    <div class="close-btn-outer" [ngClass]="{ langArMobileBtn: lang == 'ar' }">
        <button mat-mini-fab color="warn"  (click)="close()">
            <mat-icon>close</mat-icon>
        </button>
    </div>
    <div mat-dialog-content style="min-height: 63vh; max-height: none">
        <div fxLayout="row wrap">
            <div
                fxFlex="100"
                fxFlex.gt-sm="50"
                style="height: 350px"
                class="media-height-mobile"
            >
                <mat-chip-list
                    [ngClass]="{ 'lang-discount': lang == 'ar' }"
                    *ngIf="product.discount_price !== null"
                >
                    <mat-chip color="warn" selected="true" translate class="discount-precentage" >
                        {{
                            ((product.price - product.discount_price) /
                                product.price) *
                                100 | number: "1.0-0"
                        }}%
                        <span *ngIf="environmentVariables?.ENABLE_SHOW_OFF_IN_PRODUCT_LABEL">
                          {{ "productDetails.off" | translate }}
                        </span>
                    </mat-chip>
                </mat-chip-list>
                <mat-chip-list *ngIf="product.discount_price == null">
                    <mat-chip
                        *ngIf="product.promotion"
                        style="z-index: 3"
                        color="warn"
                        selected="true"
                        translate
                    >
                        {{ product.promotion }}
                    </mat-chip>
                </mat-chip-list>
                <img  loading="lazy" 
                    [src]="product?.image"
                       alt="product image"
                    onError="this.src='./../../../assets/images/others/placeholder200.png';"
                    default="./../../../assets/images/others/placeholder200.png"
                    class="swiper-lazy media-width-image"
                    style="width: 100%; height: 100%; object-fit: scale-down"
                />
            </div>

            <div
                fxFlex="100"
                [ngClass]="{ 'text-right': this.lang == 'ar' }"
                class="parentText"
                fxFlex.gt-sm="50"
                ngClass.gt-sm="px-2 m-0"
                ngClass.sm="mt-2"
                ngClass.xs="mt-2"
                style="height: 70vh"
            >
                <span *ngIf="lang == 'ar'" class="text-rightRtl product-name">
                    {{ product.name }}
                    <!-- {{ product.name | slice: 0:30 }} -->
                    <!-- <span *ngIf="product.name.length > 31">...</span> -->
                </span>
                <div *ngIf="lang == 'ar'" class="py-1 lh text-rightRtl">
                    <p>
                        <span class="text-muted fw-500" translate
                            >{{ "productDetails.category" | translate }}: </span
                        ><span>{{ product.category.name }}</span>
                    </p>
                    <p>
                        <span class="text-muted fw-500" translate
                            >{{
                                "productDetails.availablity" | translate
                            }}:</span
                        >
                        <span
                            *ngIf="product?.in_stock || product?.available_soon"
                            translate
                            >{{ "productDetails.inStocks" | translate }}</span
                        >
                        <span
                            *ngIf="
                                !product.in_stock && !product?.available_soon
                            "
                            translate
                            >{{ "home_Page.outOfStouck" | translate }}</span
                        >
                        <span
                            *ngIf="!product.in_stock && product?.available_soon"
                            translate
                            >{{
                                "productDetails.availableSoon" | translate
                            }}</span
                        >
                    </p>
                </div>
                <h1 class="product-name" *ngIf="lang == 'en'">
                    <!-- {{ product.name | slice: 0:30 }} -->
                    {{ product.name}}
                    <!-- <span *ngIf="product.name.length > 31">...</span> -->
                </h1>
                <div class="py-1 lh" *ngIf="lang == 'en'">
                    <p>
                        <span class="text-muted fw-500" translate
                            >{{ "productDetails.category" | translate }}: </span
                        ><span>{{ product.category.name }}</span>
                    </p>
                    <p>
                        <span class="text-muted fw-500" translate
                            >{{
                                "productDetails.availablity" | translate
                            }}:</span
                        >
                        <span
                            *ngIf="product?.in_stock || product?.available_soon"
                            translate
                            >{{ "productDetails.inStocks" | translate }}</span
                        >
                        <span
                            *ngIf="
                                !product.in_stock && !product?.available_soon
                            "
                            translate
                            >{{ "home_Page.outOfStouck" | translate }}</span
                        >
                        <span
                            *ngIf="!product.in_stock && product?.available_soon"
                            translate
                            >{{
                                "productDetails.availableSoon" | translate
                            }}</span
                        >
                    </p>
                </div>

                <p
                    class="py-1 text-muted lh mobile-style"
                    *ngIf="lang == 'en'"
                    style="min-height: 44px"
                    [innerHTML]="
                        lang == 'ar'
                            ? product.description_ar
                            : product.description_en
                    "
                ></p>

                <div class="divider"></div>
                <div class="d-flex">
                    <span class="text-muted fw-500 label-text mx-2"
                        >{{ "orders.Price" | translate }}:
                    </span>
                    <p
                        class="mt-2 oldPrice mx-2"
                        [ngClass]="{
                            'old-price text-muted':
                                product.discount_price !== null,
                            'new-price': product.discount_price == null,
                            'lang-ar-left': lang == 'ar'
                        }"
                    >
                        <span class="  " style="font-weight: 500" translate
                            >{{ product.price | number: "1.0-0" }}
                            {{
                                lang == "en"
                                    ? environmentVariables?.CURRENCY_CODE_EN
                                    : environmentVariables?.CURRENCY_CODE_AR
                            }}</span
                        >
                    </p>
                    <p
                        class="new-price"
                        [ngClass]="{ 'lang-ar-left': lang == 'ar' }"
                        *ngIf="product.discount_price !== null"
                        translate
                    >
                        {{ product.discount_price | number: "1.0-0" }}
                        {{
                            lang == "en"
                                ? environmentVariables?.CURRENCY_CODE_EN
                                : environmentVariables?.CURRENCY_CODE_AR
                        }}
                    </p>
                </div>

                <div class="footer-share">
                    <div
                        class="text-left py-2"
                        style="padding-left: 0px !important"
                    >
                        <div class="text-right mb-2">
                            <div
                                class="social-icon"
                                (click)="shareWithFB(product)"
                            >
                                <img  loading="lazy" 
                                    src="./../../../assets/images/others/facebook.svg"
                                       alt="facebook image"
                                />
                            </div>
                            <!-- <div
                                class="social-icon show-in-all-hidden-mobile-share"
                            >
                                <img  loading="lazy" 
                                    src="./../../../assets/images/others/messenger.svg"
                                    (click)="shareWithMessenger(product)"
                                />
                            </div> -->
                            <!-- <div class="social-icon show-in-mobile-share">
                                <img  loading="lazy" 
                                    src="./../../../assets/images/others/messenger.svg"
                                    (click)="shareWithMessengerMobile(product)"
                                />
                            </div> -->
                            <div
                                class="social-icon show-in-all-hidden-mobile-share"
                            >
                                <img  loading="lazy" 
                                    src="./../../../assets/images/others/whatsapp.svg"
                                       alt="whatsapp image"
                                    (click)="shareWithWhatsapp(product)"
                                />
                            </div>
                            <div class="social-icon show-in-mobile-share">
                                <img  loading="lazy" 
                                    src="./../../../assets/images/others/whatsapp.svg"
                                       alt="whatsapp image"
                                    (click)="shareWithWhatsappMobile(product)"
                                />
                            </div>
                            <div
                                class="social-icon show-in-all-hidden-mobile-share"
                            >
                                <img  loading="lazy" 
                                    src="./../../../assets/images/others/twitter.svg"
                                       alt="twitter image"
                                    (click)="shareWithTW(product)"
                                />
                            </div>
                            <div class="social-icon show-in-mobile-share">
                                <img  loading="lazy" 
                                    src="./../../../assets/images/others/twitter.svg"
                                       alt="twitter image"
                                    (click)="shareWithTWMobile(product)"
                                />
                            </div>
                            <div class="social-icon">
                                <img  loading="lazy" 
                                    src="./../../../assets/images/others/copy.svg"
                                       alt="social-icon-image"
                                    (click)="
                                        copyInputMessage(product.share_link)
                                    "
                                />
                            </div>
                        </div>
                        <p class="urlCopy">
                            {{ product.share_link }}
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
